import { ReactNode } from "react";
import { urls } from "../../urls";
import { SendMoneyLink } from "./SendMoneyLink";

/**
 * Drawer is a sidebar that is always visible on the left side of the screen.
 * It is used to display navigation items and other content.
 */
export function Drawer({
  children,
  logoSection,
  onClick,
}: {
  children: ReactNode;
  logoSection: ReactNode;
  onClick: () => void;
}) {
  return (
    <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
      <div className="flex h-16 shrink-0 items-center justify-center pt-12">
        {logoSection}
        {/* <Logo className="w-40" /> */}
      </div>
      <div className="flex h-16 shrink-0 items-center justify-center pt-14">
        <SendMoneyLink href={urls.sendMoney.start.href} onClick={onClick} />
      </div>
      {children}
    </div>
  );
}
